import standardSections from './Standard-City';
import { cityMap } from './Cities';

const sections = standardSections("james.nelson.ii@gmail.com");


cityMap['chicago'].sections = sections;
cityMap['chicago'].eventStartLocation = "Lincoln Park Zoo";



// WEBPACK FOOTER //
// ./src/cities/Chicago.js